var _path, _g, _g2, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEasyAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.609375 40.7827C0.609375 42.2357 1.18655 43.6291 2.21392 44.6564C3.24129 45.6838 4.63471 46.261 6.08764 46.261H43.8268C45.2797 46.261 46.6731 45.6838 47.7005 44.6564C48.7279 43.6291 49.305 42.2357 49.305 40.7827V17.9566C49.305 17.2302 49.0164 16.5335 48.5028 16.0198C47.9891 15.5061 47.2924 15.2175 46.5659 15.2175L3.34851 15.2175C3.34851 14.491 3.63709 13.7943 4.15078 13.2806C4.66446 12.767 5.36117 12.4784 6.08764 12.4784H47.9355C48.2987 12.4784 48.647 12.3341 48.9039 12.0772C49.1607 11.8204 49.305 11.472 49.305 11.1088C49.305 10.7456 49.1607 10.3972 48.9039 10.1404C48.647 9.88354 48.2987 9.73925 47.9355 9.73925H6.08764C4.63471 9.73925 3.24129 10.3164 2.21392 11.3438C1.18655 12.3712 0.609375 13.7646 0.609375 15.2175L0.609375 40.7827Z",
    fill: "url(#paint0_linear_13878_11622)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_13878_11622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.0007,
    cy: 40.7827,
    r: 13.3913,
    fill: "#143239",
    fillOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_13878_11622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.9995,
    cy: 40.7827,
    r: 10.9565,
    fill: "#EDF0F5",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9995,
    cy: 40.7827,
    r: 9.53404,
    stroke: "white",
    strokeWidth: 2.84496
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2674 34.9746C41.6722 34.6025 42.3286 34.6025 42.7335 34.9746L46.5664 38.4972C46.9712 38.8692 46.9712 39.4725 46.5664 39.8446C46.1615 40.2166 45.5051 40.2166 45.1003 39.8446L43.0371 37.9484V41.9326V45.9167C43.0371 46.4429 42.573 46.8695 42.0004 46.8695C41.4279 46.8695 40.9638 46.4429 40.9638 45.9167V37.9484L38.9006 39.8446C38.4957 40.2166 37.8393 40.2166 37.4345 39.8446C37.0296 39.4725 37.0296 38.8692 37.4345 38.4972L41.2674 34.9746Z",
    fill: "url(#paint1_linear_13878_11622)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_13878_11622",
    x: 13.0298,
    y: 11.8118,
    width: 57.9423,
    height: 57.9418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.78977
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13878_11622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13878_11622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_13878_11622",
    x: 15.4634,
    y: 14.2466,
    width: 53.0712,
    height: 53.0722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.78977
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13878_11622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13878_11622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13878_11622",
    x1: -0.417802,
    y1: 8.92765,
    x2: 85.5001,
    y2: 60.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13447,
    stopColor: "#38B2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677447,
    stopColor: "#F7E74E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13878_11622",
    x1: 39.5815,
    y1: 36.9186,
    x2: 52.3028,
    y2: 42.7749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4DE5F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyAccount);
export default __webpack_public_path__ + "static/media/easy-account.0c86668d0d545133532771212c9205dd.svg";
export { ForwardRef as ReactComponent };